import _ from "lodash";

import { z } from "zod";
import { fileUploadTypes, imageTypes, MAX_FILE_SIZE_IN_BYTES } from "../constants";
import { validateFileSize } from "./helpers";

const MAX_FILE_SIZE_IN_MB = MAX_FILE_SIZE_IN_BYTES / (1024 * 1024);

export const letterSchema = z.object({
    attached_documents: z.instanceof(File)
                            .refine((file) => fileUploadTypes.includes(file.type),  `Files must be one of the following ${fileUploadTypes.join(', ')}`)
                            .refine((file) => validateFileSize(file),  `Files must be less than ${(MAX_FILE_SIZE_IN_MB).toFixed(2)} MB}`)
                            .nullable(),
    digital_signature: z.instanceof(File)
                            .refine((file) => imageTypes.includes(file.type), `Files must be one of the following ${imageTypes.join(', ')}`)
                            .refine((file) => validateFileSize(file),  `Files must be less than ${(MAX_FILE_SIZE_IN_MB).toFixed(2)} MB}`)
                            .nullable(),
    emails_of_recipients: z.array(z.string().email()).refine((list) => _.uniq(list).length === list.length, 'Email list must be unique'),
    status: z.string(),
    subject: z.string({ required_error: '*this field is required' }).min(1, 'Subject must be at least 1 character'),
    comments: z.string().optional(),
    message: z.string({ required_error: '*this field is required' }).min(1, 'Message must be at least 1 character'),
    digital_reference_number: z.string(),
    letterType: z.string()
});

export const externalLetterSchema = z.object({
    attached_documents: z.instanceof(File)
                            .refine((file) => fileUploadTypes.includes(file.type),  `Files must be one of the following ${fileUploadTypes.join(', ')}`)
                            .refine((file) => validateFileSize(file),  `Files must be less than ${(MAX_FILE_SIZE_IN_MB).toFixed(2)} MB}`)
                            .nullable(),
    subject: z.string({ required_error: '*this field is required' }).min(1, 'Subject must be at least 1 character'),
    comments: z.string().optional(),
    message: z.string({ required_error: '*this field is required' }).min(1, 'Message must be at least 1 character'),
    digital_reference_number: z.string(),
});
  

export const newLetterSchema = z.object({
    attached_documents: z.instanceof(File)
                            .refine((file) => fileUploadTypes.includes(file.type),  `Files must be one of the following ${fileUploadTypes.join(', ')}`)
                            .refine((file) => validateFileSize(file),  `Files must be less than ${(MAX_FILE_SIZE_IN_MB).toFixed(2)} MB}`)
                            .nullable(),
    digital_signature: z.instanceof(File)
                            .refine((file) => imageTypes.includes(file.type), `Files must be one of the following ${imageTypes.join(', ')}`)
                            .refine((file) => validateFileSize(file),  `Files must be less than ${(MAX_FILE_SIZE_IN_MB).toFixed(2)} MB}`)
                            .nullable(),
    emails_of_recipients: z.array(z.string().email()).min(1, 'Email must have at least 1 recipient').refine((list) => _.uniq(list).length === list.length, 'Email list must be unique'),
    status: z.string(),
    subject: z.string({ required_error: '*this field is required' }).min(1, 'Subject must be at least 1 character'),
    comments: z.string().optional(),
    message: z.string({ required_error: '*this field is required' }).min(1, 'Message must be at least 1 character'),
    letterType: z.string()
});